import { Feature } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Feature()
export class DocPersonalizationFeature {
}
